import { getJitterTime } from './jitter';

const oneSecond = 1000;
const twoSeconds = 2 * 1000;
const fiveSeconds = 5 * 1000;
const twentySeconds = 20 * 1000;
const thirtySeconds = 30 * 1000;

const minCallbackJitterDelay = twoSeconds;
const maxCallbackJitterDelay = fiveSeconds;

const minRetryTime = oneSecond;
const maxRetryTime = twentySeconds;

export const throttleTime = thirtySeconds;

let callbackDelay: number | undefined;

let retryDelay: number | undefined;

type GetCallbackDelay = () => number;
export const getCallbackDelay: GetCallbackDelay = () => {
  if (!callbackDelay) {
    callbackDelay = getJitterTime(minCallbackJitterDelay, maxCallbackJitterDelay);
  }

  return callbackDelay;
};

type GetRetryDelay = () => number;
export const getRetryDelay: GetRetryDelay = () => {
  if (!retryDelay) {
    retryDelay = getJitterTime(minRetryTime, maxRetryTime);
  }

  return retryDelay;
};
